import React from "react";
import styled from "styled-components";
import { BsTwitter } from "react-icons/bs";
import { FaMobile, FaBuilding } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { ImMail3 } from "react-icons/im";
import utbLogo from "../assets/UTBLogo.jpg";
export default function Footer() {
	return (
		<FooterContainer id="footer">
			<FooterWrapper>
				<ContactUs>
					<FooterHeader>Contact Us</FooterHeader>
					<FooterRow>Grand Imperial Hotel</FooterRow>
					<FooterRow>Plot 6/6A Nile Avenue, 2nd Floor</FooterRow>
					<FooterRow>P. O. Box 5184 Kampala, Uganda</FooterRow>
					<FooterRow>
						+256 776 690915 | +256 782 026900 | +256 702 026900
					</FooterRow>
					<FooterRow>info@fleetlineug.com | thomas@fleetlineug.com</FooterRow>
				</ContactUs>
				<SocialMedia>
					<FooterHeader>Social Media</FooterHeader>
					<FooterRow clickable>
						<FooterSocial>
							<AiFillInstagram />
						</FooterSocial>
						Instagram
					</FooterRow>
					<FooterRow clickable>
						<FooterSocial>
							<BsTwitter />
						</FooterSocial>
						Twitter
					</FooterRow>
				</SocialMedia>
				<Accreditation>
					<img src={utbLogo} alt="" />
					<span> We're regulated by UTB</span>
				</Accreditation>
			</FooterWrapper>
			<CopyRight>
				<span>
					Copyright &copy; 2022 FleetLine Tours Uganda. All rights reserved
				</span>
			</CopyRight>
		</FooterContainer>
	);
}

const Accreditation = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	font-weight: 500;

	img {
		//opacity: 0.7;
		width: 80px;
		border-radius: 10px;
	}

	span {
		font-size: 13px;
	}
`;

const SocialMedia = styled.div`
	ul {
		display: flex;
		list-style-type: none;
		gap: 2rem;
		li {
			a {
				text-decoration: none;
				color: black;
				transition: 0.3s ease-in-out;
				&:hover {
					color: green;
				}
			}
			svg {
				font-size: 1.3rem;
				transition: 0.3s ease-in-out;
				&:hover {
					color: green;
					cursor: pointer;
				}
			}
		}
	}
`;
const ContactUs = styled.div`
	font-size: 15px;
`;
const CopyRight = styled.div``;
const MenuLinks = styled.div`
	ul {
		display: flex;
		list-style-type: none;
		gap: 2rem;
		li {
			a {
				text-decoration: none;
				color: black;
				transition: 0.3s ease-in-out;
				&:hover {
					color: green;
				}
			}
			svg {
				font-size: 1.3rem;
				transition: 0.3s ease-in-out;
				&:hover {
					color: green;
					cursor: pointer;
				}
			}
		}
	}
`;

const FooterContainer = styled.footer`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
	background-color: #d1e7f6;
	border-radius: 0.7rem;
	padding: 1rem;

	@media screen and (min-width: 280px) and (max-width: 1024px) {
		flex-direction: column;
		gap: 2rem;
		ul {
			flex-direction: column;
		}
		.social__links {
			flex-direction: row;
		}
	}
`;

const FooterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 10px 30px;
	width: 100%;
	@media screen and (min-width: 280px) and (max-width: 768px) {
		flex-direction: column;
	}
`;

const FooterHeader = styled.p`
	padding: 10px;
	font-weight: 600;
	font-size: 24px;
`;

const FooterRow = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	font-size: 18px;
	padding: 0 10px;
	&:hover {
		color: ${({ clickable }) => clickable && "green"};
	}
	cursor: ${({ clickable }) => clickable && "pointer"};
`;

const FooterSocial = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3px;
	font-size: 24px;
`;
